import { render, staticRenderFns } from "./SubscriptionPlan.vue?vue&type=template&id=1aaf9a5c&scoped=true&"
import script from "./SubscriptionPlan.vue?vue&type=script&lang=ts&"
export * from "./SubscriptionPlan.vue?vue&type=script&lang=ts&"
import style0 from "./SubscriptionPlan.vue?vue&type=style&index=0&id=1aaf9a5c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaf9a5c",
  null
  
)

export default component.exports